function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
// @ts-ignore
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import ControlPanel from './ControlPanel';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import useWindowDimensions from '../../hooks/useWindowDimensions';

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;
var PDFReader = function PDFReader(_ref) {
  var url = _ref.url,
    goToFirstPageButton = _ref.goToFirstPageButton,
    goToNextPageButton = _ref.goToNextPageButton,
    goToPreviousPageButton = _ref.goToPreviousPageButton,
    goToLastPageButton = _ref.goToLastPageButton,
    zoomInButton = _ref.zoomInButton,
    zoomOutButton = _ref.zoomOutButton,
    downloadButton = _ref.downloadButton,
    printButton = _ref.printButton,
    loader = _ref.loader,
    width = _ref.width,
    height = _ref.height,
    dualPageWidthThreshold = _ref.dualPageWidthThreshold,
    _ref$defaultScale = _ref.defaultScale,
    defaultScale = _ref$defaultScale === void 0 ? 1.0 : _ref$defaultScale;
  var _useState = useState(defaultScale),
    _useState2 = _slicedToArray(_useState, 2),
    scale = _useState2[0],
    setScale = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    numPages = _useState4[0],
    setNumPages = _useState4[1];
  var _useState5 = useState(1),
    _useState6 = _slicedToArray(_useState5, 2),
    pageNumber = _useState6[0],
    setPageNumber = _useState6[1];
  var _useState7 = useState(1),
    _useState8 = _slicedToArray(_useState7, 2),
    renderedPageNumber = _useState8[0],
    setRenderedPageNumber = _useState8[1];
  var _useWindowDimensions = useWindowDimensions(),
    windowWidth = _useWindowDimensions.width;
  var isLoading = renderedPageNumber !== pageNumber;
  var onDocumentLoadSuccess = function onDocumentLoadSuccess(_ref2) {
    var numPagesTemp = _ref2.numPages;
    setNumPages(numPagesTemp);
  };
  var showDualPage = dualPageWidthThreshold ? windowWidth > dualPageWidthThreshold : false;
  var renderPage = function renderPage(pageNumberToRender, isPageLoading, renderedPageNum) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, isPageLoading && renderedPageNum ? /*#__PURE__*/React.createElement(Page, {
      key: renderedPageNum,
      pageNumber: renderedPageNum,
      scale: scale,
      width: width,
      height: height
    }) : null, /*#__PURE__*/React.createElement(Page, {
      className: "".concat(isPageLoading ? 'loadingPage' : ''),
      key: pageNumberToRender,
      pageNumber: pageNumberToRender,
      scale: scale,
      width: width,
      height: height,
      onRenderSuccess: function onRenderSuccess() {
        return setRenderedPageNumber(pageNumberToRender);
      }
    }));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ControlPanel, {
    scale: scale,
    setScale: setScale,
    numPages: numPages,
    pageNumber: pageNumber,
    setPageNumber: setPageNumber,
    file: url,
    goToFirstPageButton: goToFirstPageButton,
    goToPreviousPageButton: goToPreviousPageButton,
    goToNextPageButton: goToNextPageButton,
    goToLastPageButton: goToLastPageButton,
    zoomInButton: zoomInButton,
    zoomOutButton: zoomOutButton,
    downloadButton: downloadButton,
    printButton: printButton,
    dualPage: showDualPage
  }), /*#__PURE__*/React.createElement(Document, {
    file: url,
    onLoadSuccess: onDocumentLoadSuccess,
    onLoadError: console.error,
    loading: loader
  }, showDualPage ? /*#__PURE__*/React.createElement("div", {
    className: "PDFReader__dualPage"
  }, renderPage(pageNumber, isLoading, renderedPageNumber), pageNumber < numPages && renderPage(pageNumber + 1, isLoading, renderedPageNumber + 1)) : renderPage(pageNumber, isLoading, renderedPageNumber)));
};
export default PDFReader;